import React, { FunctionComponent } from 'react';
import { HotelStars } from '@lt/components';

import { LocationLabel, Row } from './PackageMetaTitle.style';

type Props = {
  location: string;
  starCount?: number;
  parentWidth?: number;
};

export const PackageMetaTitle: FunctionComponent<Props> = ({
  location,
  starCount,
  parentWidth,
}) => {
  return (
    <Row parentWidth={parentWidth}>
      <HotelStars value={starCount} showMeta />
      <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
        <LocationLabel itemProp="addressRegion">{location}</LocationLabel>
      </div>
    </Row>
  );
};
